import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, Drawer } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../styled/index.styled";
import { SwitchComponent } from "./configurationTabPane/components/SwitchComponent";

const Footer = (props) => {
  const CANCEL = useTranslation({ id: "cancel" });
  const CONFIRM = useTranslation({ id: "confirm" });

  return (
    <S.DrawerFooter>
      <div className="left">
        <Button onClick={props.onClose} className="btnCancel">
          {CANCEL}
        </Button>
      </div>
      <div className="right row">
        <div className="col-sm">
          <Button type="primary" onClick={props.onConfirm} className="btn">
            {CONFIRM}
          </Button>
        </div>
      </div>
    </S.DrawerFooter>
  );
};

const DrawerProcessConfiguration = ({
  visibleDrawer,
  configurationActive,
  locationsConfigurationsProcessHideDrawer,
  locationsConfigurationsProcessUpdateFormFieldValue,
  locationsConfigurationsUpdateConfigurationProcessActive,
}) => {
  const isFeatured = 1;
  const isInternQueue = 2;
  const isInOperation = 3;
  const isFinished = 4;
  const ENABLE_OR_DISABLE_PROCESS = useTranslation({ id: "enable_or_disable_process" });
  const ENABLE_OR_DISABLE_PROCESS_DESCRIPTION = useTranslation({ id: "enabled_or_disabled_process_description" });
  const VEHICLE_STEPS_PROCESS_TITLE = useTranslation({ id: "vehicle_steps_title" });
  const EDIT_PROCESS = useTranslation({ id: "edit_process" });
  const EDITING_PROCESS_SETTINGS = useTranslation({ id: "editing_process_settings" });
  const PROCESS = useTranslation({ id: "processes" });
  const FEATURED = useTranslation({ id: "featured" });
  const INTERN_QUEUE = useTranslation({ id: "intern_queue" });
  const IN_OPERATION = useTranslation({ id: "in_operation" });
  const FINISHED = useTranslation({ id: "finished" });

  const isDisabledVehicleSteps = configurationActive.active === false;

  const onConfirm = () => {
    locationsConfigurationsProcessHideDrawer();
    locationsConfigurationsProcessUpdateFormFieldValue(configurationActive);
  };

  const onClose = () => {
    locationsConfigurationsProcessHideDrawer();
  };

  const handleToggleChange = (checked: boolean) => {
    locationsConfigurationsUpdateConfigurationProcessActive({
      ...configurationActive,
      vehicleSteps: !checked ? [] : configurationActive.vehicleSteps,
      active: checked,
    });
  };

  const onChangeVehicleSteps = (processConfiguration, id, e) => {
    const { checked } = e.target;
    const updatedProcess = {
      ...processConfiguration,
      vehicleSteps: checked ? [...(processConfiguration.vehicleSteps || []), id] : processConfiguration.vehicleSteps?.filter((vehicleStepId) => vehicleStepId !== id),
    };
    locationsConfigurationsUpdateConfigurationProcessActive(updatedProcess);
  };

  return (
    <Drawer
      title={EDIT_PROCESS}
      placement="right"
      open={visibleDrawer}
      width="460"
      closeIcon={false}
      maskClosable={true}
      closable={true}
      onClose={() => {
        locationsConfigurationsUpdateConfigurationProcessActive(null);
        locationsConfigurationsProcessHideDrawer();
      }}
      destroyOnClose={false}
      extra={
        <S.CloseDrawer onClick={() => locationsConfigurationsProcessHideDrawer()} data-testid="closeIcon">
          <CloseOutlined className="closeIcon" />
        </S.CloseDrawer>
      }
      footer={<Footer onClose={onClose} onConfirm={onConfirm} />}
    >
      <S.TitleDescription>{EDITING_PROCESS_SETTINGS}</S.TitleDescription>
      <S.ProcessDescription>{PROCESS}</S.ProcessDescription>
      <S.ProcessTitle>{configurationActive ? configurationActive.description : ""}</S.ProcessTitle>
      <S.Description>{ENABLE_OR_DISABLE_PROCESS}</S.Description>
      <SwitchComponent
        title={ENABLE_OR_DISABLE_PROCESS_DESCRIPTION}
        checked={configurationActive?.active}
        name={configurationActive?.description}
        onChange={handleToggleChange}
        dataTestId={`toggle-${configurationActive?.description}`}
      />
      <S.Description>{VEHICLE_STEPS_PROCESS_TITLE}</S.Description>

      <S.VehicleStepsContainer>
        <Checkbox
          disabled={isDisabledVehicleSteps}
          checked={configurationActive.vehicleSteps?.includes(isFeatured)}
          onChange={(e) => onChangeVehicleSteps(configurationActive, isFeatured, e)}
        >
          {FEATURED}
        </Checkbox>
        <Checkbox
          disabled={isDisabledVehicleSteps}
          checked={configurationActive.vehicleSteps?.includes(isInternQueue)}
          onChange={(e) => onChangeVehicleSteps(configurationActive, isInternQueue, e)}
        >
          {INTERN_QUEUE}
        </Checkbox>
        <Checkbox
          disabled={isDisabledVehicleSteps}
          checked={configurationActive.vehicleSteps?.includes(isInOperation)}
          onChange={(e) => onChangeVehicleSteps(configurationActive, isInOperation, e)}
        >
          {IN_OPERATION}
        </Checkbox>
        <Checkbox
          disabled={isDisabledVehicleSteps}
          checked={configurationActive.vehicleSteps?.includes(isFinished)}
          onChange={(e) => onChangeVehicleSteps(configurationActive, isFinished, e)}
        >
          {FINISHED}
        </Checkbox>
      </S.VehicleStepsContainer>
    </Drawer>
  );
};

export default DrawerProcessConfiguration;
